import styled from "styled-components";
import {GameDefaultBox} from "./game.default.box";

export const GameCisBox = styled(GameDefaultBox)`
    margin-bottom: 0;
    margin-top: 0;
    padding: 0 0 2rem 0;
`;